import qs from "qs";
import configure, { apiUrls } from '@/constant/configure';
import api from "@/helpers/api_helper";
import delay from "@/utils/delay";

export const getEventBannerList = async () => {
    try {
        return [
            {
                id: 'est222', title: '앱 출시 기념 감사 이벤트',
                bannerImage: 'https://picsum.photos/1500/1000',
                image: 'https://picsum.photos/1500/1000',
                description: ''
            }
        ]
        return await api.get(`/hooking-soup/banner`, { baseURL: apiUrls.studio }).then(r => r.data)
    } catch (error) { throw error }
}